import { RefObject } from 'react';

export const isEllipsisActive = (ref: RefObject<HTMLDivElement>) => {
  return ref.current && ref.current.offsetWidth < ref.current.scrollWidth;
};
